//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";

export default {
  components: {
    SuccessDialog,
  },
  data() {
    return {
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      company_list: [],

      formData: {
        id: null,
        cust_account: "",
        status: "A",
        customer_type: "Individual",

        // Primary Client Information
        primary_name: "",
        primary_abbreviation: "",
        primary_company_id: localStorage.getItem(server.COMPANYID),
        primary_address: "",
        primary_province: "",
        primary_country: "",
        primary_postcode: "",
        primary_email: "",
        primary_tel: "",
        primary_contact: "",
        primary_mobile: "",
        primary_fax: "",

        // Secondary Client Information
        secondary_name: "",
        secondary_abbreviation: "",
        secondary_company_id: Number(localStorage.getItem(server.COMPANYID)),
        secondary_address: "",
        secondary_province: "",
        secondary_country: "",
        secondary_postcode: "",
        secondary_email: "",
        secondary_tel: "",
        secondary_contact: "",
        secondary_mobile: "",
        secondary_fax: "",

        // Invoice/Receipt Information
        same_address_as_primary: false,
        invoice_address: "",
        invoice_province: "",
        invoice_country: "",
        invoice_postcode: "",
        invoice_currency: "THB",
        invoice_tax_id: "",
        invoice_branch: "",
        invoice_contact_name: "",
        invoice_contact_position: "",
        invoice_vat: 0,
        invoice_vat_type: "E",
        invoice_payment_term: 0,
      },

      emp_status: [
        { id: "A", status_name: "Active" },
        { id: "D", status_name: "Inactive" },
      ],

      vat_type_list: [
        { id: "I", name: "Include Vat" },
        { id: "E", name: "Exclude Vat" },
      ],

      company: [],
      currency_list: [],
    };
  },

  async mounted() {
    await this.loadCompanyMaster(localStorage.getItem(server.COMPANYID));
    await this.loadData();

    // แก้ไขตรงนี้ - แปลงเป็น number
    const companyId = parseInt(localStorage.getItem(server.COMPANYID), 10);
    this.formData.primary_company_id = companyId;
    this.formData.secondary_company_id = companyId;

    // console.log(`primary_company_id: ${this.formData.primary_company_id}`);
    // console.log(`secondary_company_id: ${this.formData.secondary_company_id}`);

    this.$hideLoader();
  },

  computed: {
    isIndividual() {
      return this.formData.customer_type === "Individual";
    },
    isBusiness() {
      return this.formData.customer_type === "Business";
    },
  },

  methods: {
    onCustomerTypeChange() {
      this.formData.primary_company_id = `${localStorage.getItem(server.COMPANYID)}`;
      this.formData.secondary_company_id = `${localStorage.getItem(server.COMPANYID)}`;
      if (this.formData.customer_type === "Individual") {
        this.formData.primary_abbreviation = "";
        // this.formData.primary_company_id = "";
        this.formData.primary_tel = "";
        this.formData.primary_mobile = "";
        this.formData.primary_fax = "";

        // ล้างข้อมูล Secondary บางส่วน
        this.formData.secondary_abbreviation = "";
        // this.formData.secondary_company_id = "";
        this.formData.secondary_tel = "";
        this.formData.secondary_mobile = "";
        this.formData.secondary_fax = "";
      }
    },

    async loadData() {
      try {
        const id = this.$route.params.id;

        if (!id) {
          this.$router.push("/customer");
          return;
        }

        this.$showLoader();
        const result = await api.getCustomersByIdEditV2(id);

        if (result.data && result.data.length > 0) {
          const customer = result.data[0];

          this.formData = {
            id: customer.id,
            cust_account: customer.cust_account,
            status: customer.status,
            customer_type: customer.customer_type || "Individual",

            // Primary Client Information
            primary_name: customer.name || "",
            primary_abbreviation: customer.abbreviation || "",
            primary_company_id: customer.company_id || "",
            primary_address: customer.address || "",
            primary_province: customer.provice || "",
            primary_country: customer.country || "",
            primary_postcode: customer.zipcode || "",
            primary_email: customer.email || "",
            primary_tel: customer.tel || "",
            primary_contact: customer.contact || "",
            primary_mobile: customer.tel_mobile || "",
            primary_fax: customer.fax || "",

            // Secondary Client Information
            secondary_name: customer.secondary_name || "",
            secondary_abbreviation: customer.secondary_abbreviation || "",
            secondary_company_id: customer.secondary_company_id || "",
            secondary_address: customer.secondary_address || "",
            secondary_province: customer.secondary_province || "",
            secondary_country: customer.secondary_country || "",
            secondary_postcode: customer.secondary_postcode || "",
            secondary_email: customer.secondary_email || "",
            secondary_tel: customer.secondary_tel || "",
            secondary_contact: customer.secondary_contact || "",
            secondary_mobile: customer.secondary_mobile || "",
            secondary_fax: customer.secondary_fax || "",

            // Invoice/Receipt Information
            same_address_as_primary: false,
            invoice_address: customer.address_invoice || "",
            invoice_province: customer.province_invoice || "",
            invoice_country: customer.country_invoice || "",
            invoice_postcode: customer.zipcode_invoice || "",
            invoice_currency: customer.currency || "THB",
            invoice_tax_id: customer.taxid || "",
            invoice_branch: customer.branch || "",
            invoice_contact_name: customer.contact_name || "",
            invoice_contact_position: customer.contact_position || "",
            invoice_vat: customer.vat || 0,
            invoice_vat_type: customer.vat_type || "E",
            invoice_payment_term: customer.payment_term || 0,
          };

          await this.loadCurrency();
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Error",
            "Customer not found",
            "text-h5 red--text text-center"
          );
          setTimeout(() => {
            this.$router.push("/customer");
          }, 1500);
        }

        this.$hideLoader();
      } catch (error) {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Error",
          "Error loading customer data",
          "text-h5 red--text text-center"
        );
        setTimeout(() => {
          this.$router.push("/customer");
        }, 1500);
      }
    },

    async loadCompanyMaster(id) {
      const result = await api.getCompanyByID(id);
      this.company_list = result.data;
      // console.log(`company_list: `, JSON.stringify(this.company_list));

      // this.company = result.data;
    },

    async loadCurrency() {
      const res_cur = await api.getDataCurrency();
      this.currency_list = res_cur.data;
    },

    copyPrimaryAddress() {
      if (this.formData.same_address_as_primary) {
        this.formData.invoice_address = this.formData.primary_address;
        this.formData.invoice_province = this.formData.primary_province;
        this.formData.invoice_country = this.formData.primary_country;
        this.formData.invoice_postcode = this.formData.primary_postcode;
      }
    },

    async save() {
      if (this.formData.primary_name == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Primary Client Name.",
          "text-h5 red--text text-center"
        );
        return;
      }

      const resChecKName = await api.getCustomerByName({
        params: {
          cus_name: this.formData.primary_name,
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });

      if (resChecKName.data.length > 0) {
        if (resChecKName.data[0].id != this.formData.id) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Primary Client Name already exists.",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      if (this.formData.customer_type == "Business") {
        if (this.formData.primary_postcode !== "") {
          if (!/^([+-]*[0-9]+[+-]*)+$/.test(this.formData.primary_postcode)) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Primary Postcode must be numbers only.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }

        if (this.formData.primary_email !== "") {
          if (
            !/^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              this.formData.primary_email
            )
          ) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Please check Primary Email format.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }

        if (this.formData.primary_tel !== "") {
          if (!/^([+-]*[0-9]+[+-]*)+$/.test(this.formData.primary_tel)) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Primary Telephone must be numbers only.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }

        if (this.formData.primary_contact !== "") {
          if (!/^([+-]*[0-9]+[+-]*)+$/.test(this.formData.primary_contact)) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Primary Contact Number must be numbers only.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }

        if (this.formData.primary_mobile !== "") {
          if (!/^([+-]*[0-9]+[+-]*)+$/.test(this.formData.primary_mobile)) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Primary Mobile Number must be numbers only.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }

        if (this.formData.invoice_postcode !== "") {
          if (!/^([+-]*[0-9]+[+-]*)+$/.test(this.formData.invoice_postcode)) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "Invoice Postcode must be numbers only.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }

        if (
          this.formData.primary_abbreviation != "" &&
          this.formData.primary_abbreviation != null
        ) {
          const res_by_id = await api.getCustomersById(this.formData.id);

          if (
            this.formData.primary_abbreviation.toUpperCase() !=
            res_by_id.data[0].abbreviation
          ) {
            const res_c = await api.getCustomerAbb(
              this.formData.primary_abbreviation
            );
            if (res_c.data[0].status_abb > 0) {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Failed",
                "Primary Abbreviation already exists.",
                "text-h5 red--text text-center"
              );
              return;
            }
          }
        }

        if (
          this.formData.secondary_abbreviation != "" &&
          this.formData.secondary_abbreviation != null
        ) {
          const res_by_id = await api.getCustomersById(this.formData.id);

          if (
            this.formData.secondary_abbreviation.toUpperCase() !=
            res_by_id.data[0].secondary_abbreviation
          ) {
            const res_c = await api.getCustomerAbb(
              this.formData.secondary_abbreviation
            );
            if (res_c.data[0].status_abb > 0) {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Failed",
                "Secondary Abbreviation already exists.",
                "text-h5 red--text text-center"
              );
              return;
            }
          }
        }
      }

      if (this.formData.secondary_postcode !== "") {
        if (!/^([+-]*[0-9]+[+-]*)+$/.test(this.formData.secondary_postcode)) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Secondary Postcode must be numbers only.",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      if (this.formData.secondary_email !== "") {
        if (
          !/^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            this.formData.secondary_email
          )
        ) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please check Secondary Email format.",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      if (this.formData.secondary_tel !== "") {
        if (!/^([+-]*[0-9]+[+-]*)+$/.test(this.formData.secondary_tel)) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Secondary Telephone must be numbers only.",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      if (this.formData.secondary_contact !== "") {
        if (!/^([+-]*[0-9]+[+-]*)+$/.test(this.formData.secondary_contact)) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Secondary Contact Number must be numbers only.",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      if (this.formData.secondary_mobile !== "") {
        if (!/^([+-]*[0-9]+[+-]*)+$/.test(this.formData.secondary_mobile)) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Secondary Mobile Number must be numbers only.",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      const updateData = {
        customer_type: this.formData.customer_type,
        status: this.formData.status,

        // Primary Client Information
        name: this.formData.primary_name,
        abbreviation: this.formData.primary_abbreviation
          ? this.formData.primary_abbreviation.toUpperCase()
          : "",
        company_id: Number(localStorage.getItem(server.COMPANYID)),
        address: this.formData.primary_address,
        provice: this.formData.primary_province,
        country: this.formData.primary_country,
        zipcode: this.formData.primary_postcode,
        email: this.formData.primary_email,
        tel: this.formData.primary_tel,
        contact: this.formData.primary_contact,
        tel_mobile: this.formData.primary_mobile,
        fax: this.formData.primary_fax,

        // Secondary Client Information
        secondary_name: this.formData.secondary_name,
        secondary_abbreviation: this.formData.secondary_abbreviation
          ? this.formData.secondary_abbreviation.toUpperCase()
          : "",
        secondary_company_id: this.formData.secondary_company_id,
        secondary_address: this.formData.secondary_address,
        secondary_province: this.formData.secondary_province,
        secondary_country: this.formData.secondary_country,
        secondary_postcode: this.formData.secondary_postcode,
        secondary_email: this.formData.secondary_email,
        secondary_tel: this.formData.secondary_tel,
        secondary_contact: this.formData.secondary_contact,
        secondary_mobile: this.formData.secondary_mobile,
        secondary_fax: this.formData.secondary_fax,

        // Invoice/Receipt Information
        address_invoice: this.formData.invoice_address,
        province_invoice: this.formData.invoice_province,
        country_invoice: this.formData.invoice_country,
        zipcode_invoice: this.formData.invoice_postcode,
        currency: this.formData.invoice_currency,
        taxid: this.formData.invoice_tax_id,
        branch: this.formData.invoice_branch,
        contact_name: this.formData.invoice_contact_name,
        contact_position: this.formData.invoice_contact_position,
        vat: this.formData.invoice_vat || 0,
        vat_type: this.formData.invoice_vat_type,
        payment_term: this.formData.invoice_payment_term || 0,

        user_update: localStorage.getItem(server.USER_ID),
      };

      try {
        this.$showLoader();
        const res_edit = await api.updateCustomer(this.formData.id, updateData);

        this.$hideLoader();
        if (res_edit.status == 200 || res_edit.status == 201) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Success",
            "Edit data success",
            "text-h5 green--text text-center"
          );

          setTimeout(() => {
            this.$router.push("/customer");
          }, 1500);
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            res_edit.data.message || "Update failed",
            "text-h5 red--text text-center"
          );
        }
      } catch (error) {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Error updating data",
          "text-h5 red--text text-center"
        );
      }
    },

    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
};
